import React from 'react'
import './Resume.css'
// import arr from '../../images/ArrowUpRight.svg'

const Resume = () => {
  return (
    <>
    <a className="ResumeBox" target='_blank'  rel="noreferrer"  href="https://drive.google.com/file/d/1LYKbf20dzv68v6jwkWsN0Fd-T7TCfHRg/view?usp=sharing">
        <div >
            <h3 className='resume'>Resume</h3>
            <div className="arr"></div>
        </div>
    </a>
    </>
  )
}

export default Resume